import TYPES from '../../types';

// Domain
import { AllianzAccountStatementEntity } from '../../domain/entities/allianz-account-statement-entity';
import { AllianzAccountStatementRepository } from '../../domain/repository/allianz-account-statement-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchAllianzAccountStatementsQuery
  extends Query<Promise<Array<AllianzAccountStatementEntity>>> {
  @Inject(TYPES.ALLIANZ_ACCOUNT_STATEMENT_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.ALLIANZ_ACCOUNT_STATEMENT_REPOSITORY)
  private readonly repository!: AllianzAccountStatementRepository;

  internalExecute(): Promise<Array<AllianzAccountStatementEntity>> {
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.loaded) {
        this.repository.search()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
